import { ButtonLevels } from '@zipari/shared-ds-util-button';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';

export type LabelsOrNotes = 'labels' | 'notes';

export interface Labels {
  title: string;
  data: string[];
}

export interface Notes {
  title: string;
  data: string;
  icon?: string;
  addNoteContent?: string;
  level?: ButtonLevels;
  hideInfoIcon?: boolean;
}

export interface LabelsAndNotes {
  labels: Labels;
  notes: Notes;
}

export interface LabelsAndNotesSection extends LabelsAndNotes {
  title: string;
  data: string | string[];
  key: string;
  showButton: boolean;
  hideInfoIcon?: boolean;
}

export interface SidePanelErrors {
  labelsErrorMessage?: string;
  notesErrorMessage?: string;
  downloadsErrorMessage?: string;
  resourcesErrorMessage?: string;
  overviewErrorMessage?: string;
}

export interface ActiveClaim {
  response?: object;
  id?: string;
  eob_document_id?: string;
}

export interface AttributeList {
  attributes: ModelAttributeConfig[];
  label: string;
}

export interface SidePanelSection {
  label: string;
  attributeList: AttributeList;
}

export interface SidePanelConfig {
  overview?: {
    label: string;
    attributeList?: AttributeList;
    customContent?: any;
  };
  custom?: {
    label: string;
    attributeList?: AttributeList;
    customContent?: any;
  };
  downloads?: {
    label: string;
    attributeList?: AttributeList;
    customContent?: any;
  };
  labelsAndNotes?: {
    label?: string;
    labelForLabels?: string;
    labelForNotes: string;
    customContent?: any;
  };
  resources?: {
    label: string;
    attributeList?: AttributeList;
    customContent?: any;
  };
  slots?: {
    beforeOveriew?: SidePanelSection;
    beforeCustom?: SidePanelSection;
    beforeDownloads?: SidePanelSection;
    beforeLabelsAndNotes?: SidePanelSection;
    beforeResources?: SidePanelSection;
  };
  showClose?: boolean;
  showBack?: boolean;
}

export const headerButtonConfig = {
  labels: {
    level: ButtonLevels.text,
    content: 'Add Labels',
    icon: 'add',
  },
  notes: {
    level: ButtonLevels.text,
    content: 'Add Notes',
    icon: 'add',
  },
};

export type HeaderButtonConfigType = typeof headerButtonConfig;

export const emptyNotesAndLabels = {
  labels: {
    title: '',
    data: [],
  },
  notes: {
    title: '',
    data: '',
  },
};

export const defaultLabelsErrorMessage =
  'There was a problem loading Labels for this claim';

export const defaultNotesErrorMessage =
  'There was a problem loading Notes for this claim';
